module.exports = __webpack_public_path__ + "img/CTSP.cdc44b07.png";